const defaultState = {
    sortingLogic: {}
};

const storePortfolioFormDataReducer = (state = defaultState, action) => {

    switch (action.type) {
        case 'SAVE_PORTFOLIOFORMDATA_FULFILLED': {
            return {
                ...state,
                portfolioFormData: action.payload
            };
        }
        default: {
            return state;
        }
    }
};

export default storePortfolioFormDataReducer;


// WEBPACK FOOTER //
// ./src/reducers/VXC/storePortfolioFormData.js